import {
  createContext,
  useContext,
  useMemo,
  type FC,
  type PropsWithChildren,
} from 'react';

//import { TrainingConnectionGalene } from 'features/training-forker/services';
import { TrainingConnectionSavvyF } from 'features/training-forker/services';
import { useAppDispatch } from 'features/app/hooks/';
import type { TrainingConnection } from 'features/training-forker/interfaces';
import { AuthContext } from 'features/auth/contexts';

const TrainingConnectionContext = createContext<TrainingConnection | undefined>(
  undefined
);

export function useTrainingConnection() {
  const context = useContext(TrainingConnectionContext);
  if (context === undefined) {
    console.warn(
      'useTrainingConnection must be used within a TrainingConnectionProvider'
    );
  }
  return context;
}

export const TrainingConnectionProvider: FC<
  PropsWithChildren<{ factory?: () => TrainingConnection }>
> = ({ children, factory }) => {
  const authToken = useContext(AuthContext);
  const dispatch = useAppDispatch();
  const trainingConnection = useMemo(
    () => (factory ? factory() : TrainingConnectionSavvyF(dispatch, authToken)),
    [factory, dispatch, authToken]
  );

  return (
    <TrainingConnectionContext.Provider value={trainingConnection}>
      {children}
    </TrainingConnectionContext.Provider>
  );
};
